(function ($) {
	'use strict';

	class TableOfContents {
		constructor() {
			this.interacted = false;

			this.init();
		}

		init() {
			if (document.querySelector('.js-in-page-jump')) {
				this.registerWaypoints();
				this.toggleInPageList();
				this.displayByDefault();
			}
		}

		highlightMenuItem(id) {
			const inPageJumpTrigger = $('.js-in-page-jump-label');
			const inPageList = $('.js-in-page-list');
			const currentClassName = 'in-page__link--active';

			if ('undefined' !== typeof id && '' !== id) {
				const text = inPageList.find('a[href="#' + id + '"]').text();

				inPageList.find(`.${currentClassName}`).removeClass(currentClassName);
				inPageList.find('a[href="#' + id + '"]').addClass(currentClassName);

				if (text !== '') {
					inPageJumpTrigger.text(text);
				} else {
					inPageJumpTrigger.text('Jump To');
				}
			}
		}

		registerWaypoints() {
			var $section = $('[data-anchor]');
			const $class = this;

			$section.each(function () {
				var id = $(this).attr('id');

				$(this).waypoint({
					handler: function (direction) {
						if ('down' === direction) {
							$class.highlightMenuItem(id);
						}
					},
				});

				$(this).waypoint({
					handler: function (direction) {
						if ('up' === direction) {
							$class.highlightMenuItem(id);
						}
					},
					offset: '-50%'
				});
			});
		}

		toggleInPageList() {
			const button = document.querySelector('.js-in-page-jump');
			const hider = document.querySelector('.js-in-page-hider');
			const links = document.querySelectorAll('.js-in-page-link');

			button.addEventListener('click', (ev) => {
				ev.preventDefault();
				button.blur();
				hider.classList.toggle('in-page__hider--active');
				this.interacted = true;
			});

			links.forEach((link) => {
				const mqToMatch = window.matchMedia('(min-width: 768px)');

				link.addEventListener('click', (ev) => {
					this.interacted = true;

					if (!mqToMatch.matches) {
						hider.classList.remove('in-page__hider--active');
					}
				});
			});
		}

		displayByDefault() {
			const mqToMatch = window.matchMedia('(min-width: 768px)');
			const bannerOrHero = document.querySelectorAll('.banner, .hero, .country-banner');
			const inPageHider = document.querySelector('.js-in-page-hider');
			const hiderClass = 'in-page__hider--active';

			mqToMatch.matches
				? inPageHider.classList.add(hiderClass)
				: inPageHider.classList.remove(hiderClass);

			if (bannerOrHero.length) {
				window.addEventListener('scroll', () => {
					if (!this.interacted) {
						const bannerHeight = bannerOrHero[0].clientHeight ?? 0;

						if (window.scrollY > bannerHeight && inPageHider.classList.contains(hiderClass)) {
							inPageHider.classList.remove(hiderClass);
						}
					}
				});

				const bannerHeight = bannerOrHero[0].clientHeight ?? 0;

				if (window.scrollY > bannerHeight && inPageHider.classList.contains(hiderClass)) {
					inPageHider.classList.remove(hiderClass);
				}
			} else {
				inPageHider.classList.remove(hiderClass);
			}
		}
	}

	$(function () {
		new TableOfContents();
	});
})(jQuery);
